import { IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledDrawerForm = styled("div")(({ theme }) => ({
    paddingTop: "5%"
}));

export const StyledForm = styled("div")(({ theme }) => ({
    margin: "1%"
}));

export const StyledIconBtn = styled(IconButton)(({ theme }) => ({
    backgroundColor: "transparent",
    border: "1px solid",
    height: "34px",
    width: "34px",
    borderRadius: "10px",
    color: "#007FFF",
    borderColor: "#E0E3E7",
}))
